import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { auth } from '../../utils/firebase';

const AdminRoute = ({ children }) => {
    const [loading, setLoading] = useState(true);  
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const adminEmails = ['isaacvelezaguirre@gmail.com',  'gianmimaz@gmail.com', 'keerthi.dev.autsai@gmail.com', 'isawills@hotmail.com']; // Replace with your actual admin email
        
        const unsubscribe = auth.onAuthStateChanged((user) => {   
            if (user && adminEmails.includes(user.email)) {
                setIsAdmin(true);
            } else {
                setIsAdmin(false);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!isAdmin) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default AdminRoute; 